import { render, staticRenderFns } from "./BulkRateChange.vue?vue&type=template&id=f5acd5ec&scoped=true"
import script from "./BulkRateChange.vue?vue&type=script&lang=js"
export * from "./BulkRateChange.vue?vue&type=script&lang=js"
import style0 from "./BulkRateChange.vue?vue&type=style&index=0&id=f5acd5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5acd5ec",
  null
  
)

export default component.exports